<template>
    <div class="count-picker">
        <button class="count-picker__btn count-picker__btn--prev" @click="intVal = (!minValueReached) ? intVal - 1 : intVal">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 223 395.65"><path d="M223,370.5a25,25,0,0,0-7.37-17.79L73.49,210.57,60.76,197.84l12.73-12.73L215.63,43A25.16,25.16,0,1,0,180,7.38L7.37,180a25.16,25.16,0,0,0,0,35.58L180,388.29a25.17,25.17,0,0,0,43-17.79Z"/></svg>
        </button>
        <span class="count-picker__number" v-text="shownValue"></span>
        <button class="count-picker__btn count-picker__btn--next" @click="intVal = (!maxValueReached) ? intVal + 1 : intVal">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 223 395.65"><path d="M223,370.5a25,25,0,0,0-7.37-17.79L73.49,210.57,60.76,197.84l12.73-12.73L215.63,43A25.16,25.16,0,1,0,180,7.38L7.37,180a25.16,25.16,0,0,0,0,35.58L180,388.29a25.17,25.17,0,0,0,43-17.79Z"/></svg>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        value: {type: Number, default: 0},
        max: {type: Number, default: null},
        min: {type: Number, default: null},
        placeholder: {type: String, default: ''}
    },
    data() {
        return {
            intVal: this.value
        }
    },
    watch: {
        intVal() {
            this.$emit('input', this.intVal);
        },
        value() {
            this.intVal = this.value;
        }
    },
    computed: {
        shownValue() {
            if(this.placeholder && this.intVal == this.min) {
                return this.placeholder;
            }

            return this.intVal;
        },
        maxValueReached() {
            if(this.max === null) {
                return false;
            }

            return (this.intVal >= this.max);
        },
        minValueReached() {
            if(this.min === null) {
                return false;
            }

            return (this.intVal <= this.min);
        }
    }
}
</script>
